<template>
  <store-recherche-provider
   name="journalPaiementFacturesAchat"
   :copy="journalPaiementStore"
   :copyChanges="changesJournalPaiementStore">
   <liste-journal-paiement
     :referenceTable="constantes.referenceTable"
     :permissions="constantes.JOURNAL_PAIEMENTS_FACTURES"
     :moduleDcf="constantes.MODULE_ACHAT"
     :nameStore="constantes.storeName"/>
 </store-recherche-provider>
</template>

<script>
import * as allTypes from '@/store/mutation-type';
import journalPaiementStore, { initialState as initialStateJournal } from '@/store/modules/journalPaiements';
import { MODULE_ACHAT } from '@/configuration/devisConf';
import { JOURNAL_PAIEMENTS_FACTURES } from '@/configuration/achat/permissionsConf';
import { REFERENCE_TABLE_JOURNAL_PAIEMENT_FACTURES_ACHAT } from '@/configuration/general/referenceTableConf';
import { JOURNAL_PAIEMENT_FACTURES_ACHAT_STORE } from '@/configuration/achat/achatConfig';
import StoreRechercheProvider from '@/components/general/store/storeRechercheProvider';
import ListeJournalPaiement from '@/components/baux/journalPaiements/listeJournalPaiement';

export default {
  data() {
    return {
      journalPaiementStore,
      constantes: {
        MODULE_ACHAT,
        JOURNAL_PAIEMENTS_FACTURES,
        referenceTable: REFERENCE_TABLE_JOURNAL_PAIEMENT_FACTURES_ACHAT,
        storeName: JOURNAL_PAIEMENT_FACTURES_ACHAT_STORE,
      },
      changesJournalPaiementStore: {
        state: initialStateJournal(MODULE_ACHAT),
        mutations: {
          [allTypes.RESET_STATE](state) {
            const s = initialStateJournal(MODULE_ACHAT);
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      },
    };
  },
  components: {
    ListeJournalPaiement,
    StoreRechercheProvider,
  },
  mounted() {
    this.setInformationPage(this.$t('pageAchat.journalPaiements.liste'));
  },
};
</script>
